// extracted by mini-css-extract-plugin
export var decrement = "numeric-input-module--decrement--258cc";
export var increment = "numeric-input-module--increment--86d2a";
export var input = "numeric-input-module--input--c0e87";
export var wrap = "numeric-input-module--wrap--00ccb";